import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { useConversationStore } from '../../../store/index.store';
import { UseTypingPersonsResult } from './index.types';

const MAX_PERSONS = 3;

export const useTypingPersons = (
  conversationId: string
): UseTypingPersonsResult => {
  const { person: personStore, ui: uiStore } = useContext(
    MobXProviderContext
  ) as RootStoreProps;

  const typingPersonIds = useConversationStore((store) =>
    store.getTypingPersonsInConversation(conversationId)
  );

  const typingPersons = typingPersonIds
    .map((personId) => ({
      contact: personStore.selectPersonValueById(personId),
      presence: uiStore.selectPersonPresenceStatus(personId.toString()),
    }))
    .filter((person) => person.contact !== null);

  return {
    firstPersons: typingPersons.slice(0, MAX_PERSONS),
    additionalPersons: typingPersons.slice(MAX_PERSONS),
  };
};
